/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HousingApplicationLogDto } from '../models/HousingApplicationLogDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HousingApplicationLogService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all the logs for a housing application.
     * @param housingApplicationGuid
     * @returns HousingApplicationLogDto OK
     * @throws ApiError
     */
    public getApplicationLogs(
        housingApplicationGuid?: string,
    ): CancelablePromise<Array<HousingApplicationLogDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingApplicationLog',
            query: {
                'housingApplicationGuid': housingApplicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
